<template>
  <b-row :class="cssClass">
    <b-col md="6">
      <b-form-group label="Logistic Type" label-class="fw-bold">
        <b-dropdown class="dropdown-select" variant="link" no-caret>
          <template slot="button-content">
            <div class="d-flex justify-content-between">
              <div>
                {{
                  brandBranch.details.logisticTypeOptions[
                    brandBranch.details.selectedLogisticType
                  ].name
                }}
              </div>
              <img src="@/assets/images/dropdown.svg" alt="Dropdown" />
            </div>
          </template>
          <b-dropdown-item v-for="(logisticType, key) in brandBranch.details
            .logisticTypeOptions" :key="key" @click="$emit('selectBranchLogisticType', brandBranch, key, index)">
            {{ logisticType.name }}
          </b-dropdown-item>
        </b-dropdown>
      </b-form-group>
    </b-col>
    <b-col md="6" class="d-flex flex-column justify-content-center">
      <div class="bg-light rounded p-2 mt-2 d-flex justify-content-between" :style="[
        brandBranch.details.selectedLogisticType.includes('now')
          ? { opacity: 0.4, cursor: 'not-allowed' }
          : { opacity: 1, cursor: 'pointer' },
      ]" @click="
        brandBranch.details.selectedLogisticType.includes('now')
          ? null
          : $emit('showScheduleModal', brandBranch)">
        <div>
          <b-img :src="require('@/assets/images/calendar.png')" alt="Calendar" />
          <span class="ml-1 align-middle">
            {{
              brandBranch.details.selectedSchedule
                ? brandBranch.details.selectedSchedule
                : "Select Schedule"
            }}
          </span>
        </div>
        <b-img :src="require('@/assets/images/chevron-right.png')" alt="Chevron Right" />
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: [
    "cssClass",
    "index",
    "brandBranch"
  ]
}
</script>
